import React from "react";
import { useIntl } from "react-intl";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";

interface Introduction {
  title: string;
}

export const Introduction: React.FC<Introduction> = ({ title }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.introduction}>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{formatMessage(messages.description)}</p>
      </div>
    </div>
  );
};
